import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@one-thd/sui-atomic-components';

export const AvailabilityStatus = ({ availability }) => {

  switch (availability) {
  case 'available': {
    return (
      <Badge
        color="success"
        size="base"
        variant="regular"
      >
          Available
      </Badge>

    );
  }
  case 'available-partially': {
    return (
      <Badge
        color="success"
        size="base"
        variant="regular"
      >
          Available Part Time
      </Badge>
    );
  }

  case 'soon-available': {
    return (
      <Badge
        color="primary"
        size="base"
        variant="outline"
      >
          Available Soon
      </Badge>
    );
  }

  default: {
    return (<></>);
  }
  }
};

AvailabilityStatus.propTypes = {
  availability: PropTypes.string.isRequired
};
